<template>
    <div class="c-notificationsV2" ref="notificationsPanel"
        :class="{'is-compact': isMobile}"
        :data-component-name="$options.name"
    >
        <div class="c-notificationsV2-list">
            <div 
                class="c-notificationsV2-list__item__wrapper" 
                v-if="conversationsList && conversationsList.data"
                ref="js-notifications-list"
                @scroll.passive="onNotificationsScroll()"
            >
                <div
                    class="c-notificationsV2-list__item"
                    :key="ni"
                    v-for="(notification, ni) in conversationsList.data"
                    :class="{
                        'is-selected': selected && selected.id==notification.id,
                        'is-unread' : !notification.read,
                        'is-deleted': deleted.includes(notification.id),
                        'is-deleting': deleting.includes(notification.id)
                    }"
                    @click="selectItem(notification)"
                >
                    <div class="-avatar" v-if="notification.assignment && notification.assignment.assignedTo">
                        <UserAvatar 
                            :name="notification.assignment.assignedTo.name"
                            :email="notification.assignment.assignedTo.email"
                            :recipients="notification.recipientsList"
                        />
                    </div>
                    <div class="-avatar" v-else-if="notification.lastConversation">
                        <UserAvatar 
                            :name="notification.lastConversation.created_by.name"
                            :email="notification.lastConversation.created_by.email"
                            :recipients="notification.recipientsList"
                        />
                    </div>
                    <div class="-avatar" v-else>
                        <UserAvatar 
                            :name="notification.created_by.name"
                            :email="notification.created_by.email"
                            :recipients="notification.recipientsList"
                        />
                    </div>
                    <div class="-details flex-grow">
                        <!-- {{notification.id}} -->
                        <!-- <h3 class="-project" v-if="notification.assignment">
                        </h3> -->
                        <div class="-title__wrap">
                            <div class="-recipient u-text-truncate" v-if="notification.project && notification.assignment && notification.assignment.assignedTo">
                                <span class="-assignedTo">{{ notification.assignment.assignedTo.name }}</span>
                            </div>
                            <div>/</div>
                            <div class="-project u-text-truncate" v-if="notification.project && notification.assignment && notification.assignment.assignedTo">
                                <span class="">{{ notification.project.name }}</span>
                            </div>
                        </div>
                        <!-- <h3 class="-project" v-if="notification.project && notification.assignment && notification.assignment.assignedTo">
                            <span class="-assignedTo">{{ notification.assignment.assignedTo.name }}</span>
                        </h3>
                        <h3 class="-project" v-if="notification.project && notification.assignment && notification.assignment.assignedTo">
                            <span class="">{{ notification.project.name }}</span>
                        </h3> -->
                        <!-- <div class="-from u-text-truncate" v-if="notification.lastConversation"> -->
                            <!-- {{ notification.lastConversation.created_by.name }} -->
                            <!-- {{ notification.lastConversation.created_by.id }} -->
                        <!-- </div> -->
                        <!-- <div class="-from" v-else>
                            {{ notification.created_by.name }}
                        </div> -->
                        <!-- {{ notification.subject }} -->
                        <div class="-subject" v-if="notification.lastConversation && notification.lastConversation.message && notification.lastConversation.message.trim()!=''">
                            <div class="u-text-truncate-2lines flex-grow" v-html="notification.lastConversation.message"></div>
                        </div>
                        <div class="-subject" v-else-if="notification.subject && notification.subject!=''">
                            <div class="u-text-truncate-2lines flex-grow" v-html="notification.subject"></div>
                        </div>
                        <div class="-subject" v-else-if="project.description">
                            <div class="u-text-truncate-2lines flex-grow" v-html="project.description"></div>
                        </div>
                    </div>
                    <div class="-actions">
                        <div class="-updated_at" v-html="getRelativeDate(notification.updated_at)"></div>

                        <div class="-delete q-ml-sm" @click.stop>
                            <q-icon name="delete" size="16px" 
                                @click="deleteNotificationConfirm(notification)"
                            />
                        </div>
                    </div>
                </div>
                <div
                    ref="js-hasMore"
                    v-if="!$apollo.loading && conversationsList && conversationsList.paginatorInfo && conversationsList.paginatorInfo.hasMorePages"
                >
                </div>
            </div>
            

            <div
                class="c-notificationsV2-list__item -status"
            >
                <div
                    v-if="$apollo.loading"
                >
                    <q-spinner
                        color="primary"
                        size="1em"
                        class="q-mr-xs"
                    />
                    Chargement en cours...
                </div>
                <div v-else>
                    <div v-if="!conversationsList || !conversationsList.data || !conversationsList.data.length">
                        Aucune conversation trouvée
                    </div>
                    <div v-else>
                        Conversations {{conversationsList.data.length}} / {{conversationsList.paginatorInfo.total}}
                    </div>
                </div>
            </div>
        </div>



        <NotificationV2
            ref="selectedNotification"
            :parentNotification="selected"
            class="c-notificationsV2-content"
            :class="{'is-selected' : selected }"
            @set-selected-details="selectedDetails=$event"
            @delete-notification="deleteNotificationConfirm($event)"
            @close-panel="selected = null"
        />



        <div class="c-notificationsV2-info__wrapper js-moreinfo-wrapper" v-show="selectedDetails">
            <div class="close-panel-button">
                <q-icon name="arrow_back_ios"
                    onclick="document.querySelector('.js-moreinfo-wrapper').classList.remove('is-active')"
                />
                <div>
                    Détails de la conversation
                </div>
            </div>
            
            <div class="-header" v-if="selectedDetails">

                <div class="-avatar" v-if="selectedDetails.assignment && selectedDetails.assignment.assignedTo">
                    <UserAvatar 
                        :name="selectedDetails.assignment.assignedTo.name"
                        :email="selectedDetails.assignment.assignedTo.email"
                    />
                </div>
                <div class="-avatar" v-else-if="selectedDetails.lastConversation">
                    <UserAvatar 
                        :name="selectedDetails.lastConversation.created_by.name"
                        :email="selectedDetails.lastConversation.created_by.email"
                    />
                </div>
                <div class="-avatar" v-else>
                    <UserAvatar 
                        :name="selectedDetails.created_by.name"
                        :email="selectedDetails.created_by.email"
                    />
                </div>
                <div class="flex-grow">
                    <!-- {{selectedDetails.id}} -->
                    <div class="-assignedTo" v-if="selectedDetails.assignment">
                        <div class="-label q-mr-sm">Affecté à</div>
                        <div class="-value q-mr-sm">
                            {{ selectedDetails.assignment.assignedTo.name }}
                            {{ selectedDetails.assignment_details }}
                            <UserProfileInfo defaultTab="schedule" v-if="selectedDetails && selectedDetails.assignments_details" :scheduleScrollTo="selectedDetails.assignments_details.start_date" :currentDate="selectedDetails.assignments_details.start_date" :userProfile="selectedDetails.assignment.assignedTo" class="q-ml-xs" />
                        </div>
                    </div>

                    <div class="-splitter"></div>

                    <div class="-project" v-if="selectedDetails.project">
                        <div class="-label q-mr-sm">Projet</div>
                        <div class="-value q-mr-sm">
                            {{ selectedDetails.project.name }}
                            <ProjectCardToggle class="q-ml-sm -userprofile-info__toggle" :myAssignments="true" :projectID="selectedDetails.project.id" :size="'14px'" />
                            <a href="" class="q-ml-sm q-link -project" title="Aller au projet"
                                v-if="selectedDetails.project && myProfile && (myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER')"
                                @click.prevent="$eventBus.$emit('jump-to-project', {projectID: selectedDetails.project.id, currentDate: selectedDetails.project.start_date})"
                             >
                                <q-icon name="launch" class="jump-to-project" size="14px"/>
                            </a>
                        </div>
                        <div class="-value q-mt-sm q-mr-sm" v-if="selectedDetails.project.description != ''" v-html="selectedDetails.project.description">
                        </div>
                    </div>

                    <div class="-splitter"></div>


                    <div class="-assignmentDetails__wrapper" v-if="selectedDetails.assignments_details">
                        <div class="-assignmentDetails">
                            <div class="-label q-mr-sm" v-if="selectedDetails.assignments_details.start_date != selectedDetails.assignments_details.end_date">Date de début</div>
                            <div class="-label q-mr-sm" v-else>Date</div>
                            <div class="-value q-mr-sm">{{ selectedDetails.assignments_details.start_date }}</div>
                        </div>
                        <div class="-assignmentDetails" v-if="selectedDetails.assignments_details.start_date != selectedDetails.assignments_details.end_date">
                            <div class="-label q-mr-sm">Date de fin</div>
                            <div class="-value q-mr-sm">{{ selectedDetails.assignments_details.end_date }}</div>
                        </div>
                        <div class="-assignmentDetails" v-if="selectedDetails.assignments_details.professions">
                            <div class="-label q-mr-sm" v-if="selectedDetails.assignments_details.professions.length>1">Métiers</div>
                            <div class="-label q-mr-sm" v-else>Métier</div>
                            <div class="-value q-mr-sm">
                                {{ selectedDetails.assignments_details.professions.map(a => a.name).join(', ') }}
                            </div>
                        </div>
                        <div class="-assignmentDetails" v-if="selectedDetails.assignments_details.count > 1">
                            <div class="-label q-mr-sm">Nombre d'affectations</div>
                            <div class="-value q-mr-sm">{{ selectedDetails.assignments_details.count }}</div>
                        </div>
                    </div>

                    <div class="-splitter"></div>
                </div>

            </div>
            <div class="-member_list__wrapper" v-if="selectedDetails && selectedDetails.recipientsList">
                <h3>Membres de la discussion</h3>
                <ul>
                    <li
                        :key="di"
                        v-for="(member, di) in selectedDetails.recipientsList"
                        class="-member_list_item"
                    >
                        <UserAvatar 
                            :name="member.name"
                            :email="member.email"
                            class="q-mr-sm"
                        />
                        <UserProfileInfo defaultTab="schedule" :userProfile="member" class="q-ml-xs" :customContent="member.name"/>
                    </li>
                </ul>
            </div>
        </div>


        <q-dialog v-model="confirmDelete">
            <q-card>
                <q-card-section class="row items-top" style="flex-wrap: nowrap;">
                    <q-avatar class="q-mt-md" icon="delete" color="red" text-color="white" />
                    <q-card-section class="column items-left" style="flex-wrap: nowrap;">
                        <span class="text-h6 red">Attention, êtes vous certain de vouloir supprimer cette conversation?</span>
                    </q-card-section>
                </q-card-section>
        
                <q-card-actions align="right">
                    <q-btn flat label="Annuler" no-caps color="grey" v-close-popup @click="notificationToDelete=null" />
                    <q-btn flat label="Supprimer" no-caps color="primary" v-close-popup @click="deleteNotification(notificationToDelete)" />
                </q-card-actions>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
    import { CONVERSATIONSLIST } from "@/graphql/notification/queries";
    import { relativeDate/*, dayOfWeekStr, dayStr, monthStr*/ } from "@/js/dateUtilities";
    import { /*DELETEPROJECTNOTIFICATIONS /*MARKASREAD, */DELETENOTIFICATIONSTHREAD/*,/* REPLYNOTIFICATION,*/ /*SENDMESSAGE */} from "@/graphql/notification/mutations"
    import NotificationV2 from './NotificationV2.vue';
    import { MYPROFILE } from '@/graphql/user/queries'
    // import Notification from './Notification.vue';

    export default {
        name: 'NotificationsV2',
        components: {
            NotificationV2,
            // Notification,
            // ProjectInternalNotes
        },
        props: {
            inPage: {
                type: Boolean,
                default: false
            },
            isMobile: {
                type: Boolean,
                default: false
            },
            projectID: {
                type: [Number, String],
                default: null
            },
        },
        data() {
            return {
                myUserProfileID: window.myUserProfileID,
                myUserProfile: window.myUserProfile,
                selectAll: null,
                // checkBox: [],
                selected: null,
                selectedDetails: null,
                // appName: process.env.VUE_APP_NAME,
                // currentTab: null,
                // queryResult: 'inbox',
                queryVariables: null,
                selectAllLabel: 'Sélectionner tout',
                pageSize: 15,
                skipQueriesStart: true,
                deleted: [],
                deleting: [],
                deletedProjects: [],
                notificationScrollTo: null,
                refreshTo: null,
                refreshDelay: 120000,
                confirmDelete: false,
                notificationToDelete: null,
                // sortedNotifications: [],
            }
        },
        mounted(){
            this.skipQueriesStart=false;
            // this.refreshConversationsList();
        },
        beforeDestroy() {
            clearTimeout(this.refreshTo);
        },
        computed: {
            // sortedNotifications() {
            //     let sortedNotifications = []

            //     if(this.conversationsList?.data) sortedNotifications = this.conversationsList.data

            //     // sortedNotifications.forEach(function(item){
            //     //     console.log(item)
            //     //     if(item.lastConversation) item.read = item.lastConversation.read;
            //     // })

            //     sortedNotifications = sortedNotifications.sort((a, b) => {
            //         return new Date(b.updated_at) - new Date(a.updated_at);
            //     });

            //     sortedNotifications = sortedNotifications.filter((item) => !this.deleted.includes(item.id))

            //     return sortedNotifications;
            // },
        },
        methods: {

            sortNotifications() {
                let sortedNotifications = []

                if(this.conversationsList?.data) sortedNotifications = this.conversationsList.data

                // sortedNotifications.forEach(function(item){
                //     console.log(item)
                //     if(item.lastConversation) item.read = item.lastConversation.read;
                // })

                sortedNotifications = sortedNotifications.sort((a, b) => {
                    return new Date(b.updated_at) - new Date(a.updated_at);
                });

                sortedNotifications = sortedNotifications.filter((item) => !this.deleted.includes(item.id))

                return sortedNotifications;
            },

            refreshConversationsList(){
                clearTimeout(this.refreshTo);

                this.refreshTo = setTimeout(() => {
                    // this.$apollo.queries.conversationsList.refresh();
                    this.getMoreConversations(1);
                    this.refreshConversationsList();
                }, this.refreshDelay);
            },

            onNotificationsScroll(){

                clearTimeout(this.notificationScrollTo);
                if(!this.conversationsList?.paginatorInfo?.hasMorePages) return;

                this.notificationScrollTo=setTimeout(() => {
                    let loadMoreEl = this.$refs["js-hasMore"];
                    let loadMoreParent = this.$refs["js-notifications-list"];
                    if (loadMoreEl) {
                        var marginTop = loadMoreEl.getBoundingClientRect().top;
                        var innerHeight = loadMoreParent.getBoundingClientRect().height+loadMoreParent.getBoundingClientRect().top;
                        if ((marginTop < innerHeight+60) && !this.loading) {
                            if(!this.conversationsList?.paginatorInfo?.hasMorePages) return;
                            this.getMoreConversations();
                        }
                    }
                }, 300);

            },
            
            getMoreConversations(page=null){

                clearTimeout(this.refreshTo);

                let isRefresh = true;
                if(!page){
                    isRefresh = false;
                    page=this.conversationsList.paginatorInfo.currentPage+1;
                }
                                
                this.$apollo.queries.conversationsList.fetchMore({
                    variables: {
                        page: page,
                        first: this.pageSize,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {

                        let filteredData = previousResult.conversationsList.data.filter(item => !fetchMoreResult.conversationsList.data.find(item2 => item2.id === item.id));


                        let data = {
                            conversationsList : {
                                __typename: previousResult.conversationsList.__typename,
                                // paginatorInfo: fetchMoreResult.conversationsList.paginatorInfo,
                                data: [...filteredData, ...fetchMoreResult.conversationsList.data],
                            }
                        }

                        if(isRefresh){
                            data.conversationsList.paginatorInfo = previousResult.conversationsList.paginatorInfo
                        }else{
                            data.conversationsList.paginatorInfo = fetchMoreResult.conversationsList.paginatorInfo
                        }

                        return data
                    }
                })
            },
            selectItem(notification){
                if(this.selected && this.selected.id==notification.id){
                    this.$refs.selectedNotification.$apollo.queries.notificationDetails.refresh()
                }else{
                    this.selected=notification;
                }
            },
            getRelativeDate(date){
                return relativeDate(date);
            },
            filterModel: function(){
                if(this.filterModel.value=="unread"){
                    // this.queryResultVariables.unread=true;
                    this.$set(this.queryResultVariables, "unread", true)

                    return;
                }else if(this.filterModel.value=="read"){
                    this.queryResultVariables.unread=false;
                    return;
                }
                this.queryResultVariables.unread=null;
                delete this.queryResultVariables.unread
            },

            deleteNotificationConfirm: function (notification) {
                this.notificationToDelete = notification;
                this.confirmDelete = true;

            },

            deleteNotification(notification=null){
                if(!notification){
                    return;
                }


                if(this.selected && this.selected.id == notification.id){
                    this.selected = null;
                    this.selectedDetails = null;
                }

                this.deleting.push(notification.id);
                this.deleted.push(notification.id);

                this.$apollo.mutate({
                    mutation: DELETENOTIFICATIONSTHREAD,
                    variables: {
                        id: notification.id
                    },
                    // update: (store, { data: { deleteNotifications } }) => {
                    // deleteNotifications.forEach(function(deleteNotification){
                    //     //     Object.keys(this.pagedNotifications).forEach(function(page){
                    //     //         let result=this.pagedNotifications[page].data.filter(obj => obj.id === deleteNotification.id)
                    //     //         if(result && !pages.includes(page))  pages.push(page)
                    //     //     }.bind(this))
                    // }.bind(this))

                    //     // if(pages.length>0){
                    //     //     pages.sort();
                    //     //     pages.forEach(function(page){
                    //     //         this.getMoreNotifications(page);
                    //     //     }.bind(this))
                    //     // }
                    // }
                })
                .then(function(){
                }.bind(this)).catch(() => {})
                .finally(() => {
                    if(this.selected?.id == notification.id){
                        this.selected = null;
                        this.selectedDetails = null;
                    }
                    this.deleted.push(notification.id);
                    this.onNotificationsScroll();
                    this.notificationToDelete = null;
                    this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
                })
            }

        },
        apollo: {
            conversationsList: {
                query: CONVERSATIONSLIST,
                fetchPolicy: 'cache-and-network',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
                skip(){
                    return this.skipQueriesStart
                },
                variables() {
                    let variables={
                        page: 0,
                        first: this.pageSize,
                    }
                    if(this.projectID){
                        variables.projectID=this.projectID
                    }
                    return {
                        ...variables,
                    }
                },
                result({ data }) {


                    if (data?.conversationsList) {
                        data.conversationsList.data = this.sortNotifications();
                        this.onNotificationsScroll();
                        this.refreshConversationsList();
                        return data.conversationsList;
                    }
                }
            },
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
            },
        },
    }
</script>

<style lang="scss">
    @import "@/scss/components/notificationsV2/NotificationsV2.scss";
</style>